export const PeFlagAtom = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none">
      <g id="ic_peru" clipPath="url('#clip0_4431_1251')">
        <path
          id="Vector"
          d="M13.333 33.333H.69a.696.696 0 0 1-.69-.701V7.368c0-.387.309-.701.69-.701h12.643v26.666Z"
          fill="#D91023"
        />
        <path
          id="Vector_2"
          d="M26.667 6.667H13.333v26.666h13.334V6.667Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_3"
          d="M39.31 33.333H26.667V6.667H39.31c.381 0 .69.314.69.701v25.264a.696.696 0 0 1-.69.701Z"
          fill="#D91023"
        />
      </g>
      <defs>
        <clipPath id="clip0_4431_1251">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
